module.exports = __webpack_public_path__ + "img/材料力学5_10 2.69ed0f93.jpg";